import Head from './Head'

export * from './Head'

export default Head
